import { ActivatedRoute } from "@angular/router";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HotToastService } from "@ngneat/hot-toast";
import { BasePage } from "./base-page";

export class BaseModal extends BasePage {
  constructor(
    protected activeModal: NgbActiveModal,
    protected override route?: ActivatedRoute,
    protected override modal?: NgbModal,
    protected override toast?: HotToastService
  ) {
    super(route, modal, toast);
  }

  close(result: any = null) {
    this.activeModal.close(result);
  }

  /**
   * Should only be used as an error or last resort
   * @param reason
   */
  dismiss(reason: string = "") {
    this.activeModal.dismiss(reason);
  }
}
